import React from 'react';
import styles from './footer.module.scss';

const Footer = () => {
  return (
    <div className={styles.root}>
      <div>© TOKACHI MUSUBI 2025</div>
    </div>
  );
};

export default Footer;
